import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { createEmployeeInvitation } from '../../../services/employeeInviteApi';
import './AddEmployee.scss';

const AddEmployee = () => {
  const { user } = useSelector((state) => state.auth);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [inviteLink, setInviteLink] = useState('');
  const [copied, setCopied] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const normalizedEmail = String(email || '').trim().toLowerCase();
    if (!normalizedEmail) {
      setError('Official email is required.');
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(normalizedEmail)) {
      setError('Please enter a valid official email address.');
      return;
    }

    try {
      setLoading(true);
      setError('');
      setSuccess('');
      setCopied(false);

      const result = await createEmployeeInvitation({
        email: normalizedEmail,
        invitedBy: user?.email || '',
      });

      setInviteLink(result.invitationUrl || '');
      setSuccess(`Invitation sent successfully to ${normalizedEmail}.`);
      setEmail('');
    } catch (err) {
      setError(err.message || 'Failed to send invitation.');
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = async () => {
    if (!inviteLink) return;
    try {
      await navigator.clipboard.writeText(inviteLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch (_error) {
      setError('Could not copy the invitation link. Please copy it manually.');
    }
  };

  return (
    <div className="add-employee-container">
      <div className="page-header">
        <h1>Invite Employee</h1>
        <p>Send a secure signup link to a new employee's official email address.</p>
      </div>

      {success ? <div className="success-message">{success}</div> : null}
      {error ? <div className="error-message">{error}</div> : null}

      <div className="employee-form-container">
        <form onSubmit={handleSubmit} className="employee-form">
          <div className="invite-panel">
            <h3>New employee invitation</h3>
            <p className="invite-hint">
              The employee receives a unique signup URL by email and can register using that official email.
            </p>

            <div className="form-group">
              <label htmlFor="invite-email">Official Email</label>
              <input
                id="invite-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="employee@myelinz.com"
                disabled={loading}
                required
              />
            </div>

            {inviteLink ? (
              <div className="invite-link-box">
                <label>Shareable invite link</label>
                <div className="invite-link-row">
                  <input type="text" value={inviteLink} readOnly />
                  <button
                    type="button"
                    className="copy-button"
                    onClick={handleCopy}
                    disabled={loading}
                  >
                    {copied ? 'Copied' : 'Copy'}
                  </button>
                </div>
              </div>
            ) : null}

            <div className="form-actions">
              <button type="submit" className="submit-button" disabled={loading}>
                {loading ? 'Sending Invite...' : 'Send Invite'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEmployee; 